{
  "Received": "รับเหรียญ",
  "Transferred": "ชำระเงิน",
  "TransferredWithBonus": "ชำระเงิน",
  "ExchangedIn": "แลกเปลี่ยน",
  "BuyOrderCompleted": "ซื้อเหรียญ",
  "SellOrderReserved": "ขายเหรียญ",
  "SellOrderRefunded": "ขายเหรียญ",
  "SellOrderRebated": "ขายเหรียญ",
  "Credited": "เพิ่มยอดคงเหลือที่ใช้ได้",
  "DebitCompleted": "ลดยอดคงเหลือที่ใช้ได้",
  "BonusActivityRewarded": "รางวัล",
  "SellOrderCompleted": "ขายเหรียญ"
}
